import { matteHeadFromCanvas } from './headMatting';

/**
 * react-easy-crop's `croppedAreaPixels` is the square bounding box of the round mask.
 * Zero alpha outside the inscribed circle so corners (outside the UI circle) never appear on the card.
 */
function applyCircularAlphaMask(canvas) {
  const w = canvas.width;
  const h = canvas.height;
  const ctx = canvas.getContext('2d');
  if (!ctx || w < 2 || h < 2) return;

  const cx = w / 2;
  const cy = h / 2;
  const r = Math.min(w, h) / 2;
  const rSq = r * r;

  const imageData = ctx.getImageData(0, 0, w, h);
  const d = imageData.data;
  for (let y = 0; y < h; y++) {
    for (let x = 0; x < w; x++) {
      const dx = x + 0.5 - cx;
      const dy = y + 0.5 - cy;
      if (dx * dx + dy * dy > rSq) {
        const i = (y * w + x) * 4;
        d[i + 3] = 0;
      }
    }
  }
  ctx.putImageData(imageData, 0, 0);
}

/**
 * Draw a pixel crop from an image onto a canvas and return a blob URL (PNG).
 * Used with react-easy-crop's croppedAreaPixels.
 */
function loadImage(src) {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.addEventListener('load', () => resolve(image));
    image.addEventListener('error', (e) => reject(e));
    image.src = src;
  });
}

/**
 * @param {string} imageSrc - data URL or blob URL
 * @param {{ x: number; y: number; width: number; height: number }} pixelCrop
 * @returns {Promise<string>} object URL for PNG blob
 */
export async function getCroppedHeadBlobUrl(imageSrc, pixelCrop) {
  const image = await loadImage(imageSrc);
  const canvas = document.createElement('canvas');
  const w = Math.max(1, Math.round(pixelCrop.width));
  const h = Math.max(1, Math.round(pixelCrop.height));
  canvas.width = w;
  canvas.height = h;
  const ctx = canvas.getContext('2d');
  if (!ctx) throw new Error('Canvas unsupported');
  ctx.drawImage(
    image,
    Math.round(pixelCrop.x),
    Math.round(pixelCrop.y),
    Math.round(pixelCrop.width),
    Math.round(pixelCrop.height),
    0,
    0,
    w,
    h
  );
  applyCircularAlphaMask(canvas);
  return matteHeadFromCanvas(canvas);
}
